import {
    SelectDropdown,
    SelectDropdownButton,
    SelectDropdownItem,
    SelectDropdownList,
} from "@ecco/ui/select-dropdown";
import { useMemo, type FC } from "react";
import {
    REGION_DROPDOWN_BUTTON_TEST_ID,
    REGION_DROPDOWN_TEST_ID,
} from "@e2e/helpers/checkout/components/shipping-details/constants";
import type { CountryCode } from "@config/site/types";
import type { SelectType } from "./Selector";

interface DropdownProps {
    title: string;
    field: string;
    isError?: boolean;
    isReadOnly?: boolean;
    setFieldValue: (field: string, value: string) => void;
    styleButton?: object;
    country: CountryCode;
    locale: string;
    testId?: string;
    items: SelectType[];
    dropdownPlacement?: "top" | "bottom";
}

export const Dropdown: FC<DropdownProps> = ({
    title,
    field,
    isReadOnly,
    setFieldValue,
    styleButton,
    country,
    locale,
    testId,
    items,
    dropdownPlacement,
}) => {
    const memoizedDropdownItems = useMemo(() => {
        return items.map((item: SelectType) => (
            <SelectDropdownItem
                data-testid={REGION_DROPDOWN_BUTTON_TEST_ID}
                value={item.value}
                key={item.name}
                onClick={() => setFieldValue(field, item.value)}
            >
                {item.name}
            </SelectDropdownItem>
        ));
    }, [country, locale]);

    if (!items.length) {
        return null;
    }

    return (
        <SelectDropdown
            matchWidth
            flip={false}
            placement={dropdownPlacement}
            preventOverflow
            variant="filled"
        >
            {({ isOpen }) => (
                <>
                    <SelectDropdownButton
                        data-testid={testId}
                        disabled={isReadOnly}
                        w={["100%", "100%"]}
                        h={["100%", "initial"]}
                        borderColor={"gray.400"}
                        fontSize={"desktopBodyTextSmall"}
                        textAlign="start"
                        sx={styleButton}
                    >
                        {title}
                    </SelectDropdownButton>
                    {isOpen && (
                        <SelectDropdownList
                            scrollHeight={300}
                            data-testid={REGION_DROPDOWN_TEST_ID}
                        >
                            {memoizedDropdownItems}
                        </SelectDropdownList>
                    )}
                </>
            )}
        </SelectDropdown>
    );
};
